export function getHintClusterBaloonPos(h, w, x, y, mapWidth) {
  const K_MAX_BALLOON_HEIGHT = h;
  const K_MAX_BALLOON_WIDTH = w;
  const placement = mapWidth - x < K_MAX_BALLOON_WIDTH ? 'left' : 'right';

  return (y < K_MAX_BALLOON_HEIGHT) ? `${placement}-end` : placement;
}

export function getHintMarkerBaloonPos(h, w, x, y, mapWidth) {
  const K_MAX_BALLOON_HEIGHT = h;
  const K_MAX_BALLOON_WIDTH = w;
  const placement = y > K_MAX_BALLOON_HEIGHT ? 'top' : 'bottom';

  if (x < K_MAX_BALLOON_WIDTH) return `${placement}-end`;
  if (mapWidth - x < K_MAX_BALLOON_WIDTH) return `${placement}-start`;

  return placement;
}
